import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import AIAgentCTA from "@/components/AIAgentCTA";

export default function CTABanner() {
  return (
    <section data-testid="cta-banner" className="relative section-y">
      <div className="container-x">
        <div className="relative overflow-hidden border border-white/[0.06] bg-gradient-to-br from-[#0d0d0d] to-[#070707] p-10 md:p-16 lg:p-20">
          <div
            aria-hidden
            className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full"
            style={{
              background:
                "radial-gradient(closest-side, rgba(212,175,55,0.18), transparent 70%)",
            }}
          />
          <div
            aria-hidden
            className="absolute inset-x-0 top-0 h-px gold-line"
          />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <div className="overline">Start the conversation</div>
              <h3 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-display font-light tracking-tight text-balance">
                Talk to our AI Strategist. <br className="hidden md:block" />
                <span className="text-zinc-400">
                  A 5 to 15-minute analysis. A senior consultant prepares your plan within 1 to 2 business days.
                </span>
              </h3>
              <div className="mt-6 flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-gold/80">
                <Clock className="w-3.5 h-3.5" /> Instant · No obligation · Confidential
              </div>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
              <AIAgentCTA testId="cta-banner-ai" />
              <Link to="/contact" className="btn-outline-white" data-testid="cta-banner-book">
                Book a Strategy Call
                <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
